import { eff } from "@/core/utils/effect-ts-abbr";
import { watchEffect } from "@vue/runtime-core";
import escapeRegexp from "escape-string-regexp";
import { Prop, Vue } from "vue-property-decorator";
import {
    AppDropdownOption,
    AppDropdownOptionDetails,
    AppDropdownOptionValue,
} from "./app-dropdown";
import { setup } from "vue-class-component";
import { useI18n } from "@/shared/composables/use-i18n";

export type AppDropdownSearchMarkedLabel = string;

export type AppDropdownSearchProps = {
    // NOTE: In `single-optional` mode it can contain single element or can be empty.
    // NOTE: In `single` mode it will always contain single element.
    selectedValues: ReadonlyMap<AppDropdownOptionValue, AppDropdownOptionDetails>;
    options: ReadonlyMap<AppDropdownOption, AppDropdownOptionDetails>;
    // NOTE: Can be used to update dropdown options after search applied.
    updateSearchResults: (
        options: ReadonlyMap<AppDropdownOption, AppDropdownOptionDetails>,
    ) => void;
};

export class AppDropdownSearchComponent extends Vue {
    @Prop({ required: true, default: new Map() })
    selectedValues!: AppDropdownSearchProps["selectedValues"];

    @Prop({ required: true, default: new Map() })
    options!: AppDropdownSearchProps["options"];

    @Prop({ required: true, default: eff.fn.identity, type: Function })
    updateSearchResults!: AppDropdownSearchProps["updateSearchResults"];

    i18n = setup(useI18n);

    searchQuery = "";

    reset(): void {
        this.searchQuery = "";
    }

    mounted() {
        watchEffect(() => {
            if (!this.searchQuery) {
                this.updateSearchResults(this.options);
                return;
            }

            const pattern = new RegExp(`(${escapeRegexp(this.searchQuery)})`, "giu");

            this.updateSearchResults(
                eff.fn.pipe(
                    this.options,
                    eff.map.filterWithIndex((_index, it) => pattern.test(it.label)),
                    eff.map.map((it) => ({
                        ...it,
                        label: it.label.replace(pattern, "<mark>$1</mark>"),
                    })),
                ),
            );
        });
    }
}

export default AppDropdownSearchComponent;
